import React, { useCallback } from "react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { CKEditor } from "@ckeditor/ckeditor5-react";
const editorConfiguration = {
    toolbar: [
        "heading",
        "|",
        "bold",
        "italic",
        "link",
        "bulletedList",
        "numberedList",
        // "|",
        // "outdent",
        // "indent",
        "|",
        // "uploadImage",
        "blockQuote",
        "insertTable",
        // "mediaEmbed",
        "undo",
        "redo",
    ],
};
const RichTextarea = ({ name, value, onChange }) => {
    const handleChange = useCallback((_event, editor) => onChange({ target: { name, value: editor.getData() } }), [onChange, name]);

    return (
        <CKEditor
            config={editorConfiguration}
            editor={ClassicEditor}
            data={value ?? ""}
            onChange={handleChange}
            onInit={(editor) => {
                // You can store the "editor" and use when it is needed.
                // console.log("Editor is ready to use!", editor);
                editor.editing.view.change((writer) => {
                    writer.setStyle("height", "200px", editor.editing.view.document.getRoot());
                });
            }}
        />
    );
};

export default RichTextarea;
